import { Avatar } from '../../../layout/Avatar.jsx';
import { formatIQD } from '../../../shared/format.js';

function normalize(data) {
  const arr = Array.isArray(data) ? data : data?.data || data?.items || [];
  return arr.slice(0, 5).map((r, i) => ({
    id: r.id ?? r.childId ?? `c${i}`,
    name: r.name ?? r.childName ?? r.fullName ?? '—',
    cardNo: r.cardNo ?? r.card ?? null,
    total: Number(r.total ?? r.amount ?? r.spend ?? 0)
  }));
}

export function TopSpendersList({ data }) {
  const rows = normalize(data);

  if (!rows.length) {
    return (
      <div className="px-4 py-10 text-center text-ink-3 text-sm">لا توجد بيانات بعد</div>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      {rows.map((r, i) => (
        <div
          key={r.id}
          className="flex items-center gap-3 px-3 py-2 rounded-[10px] border border-line hover:bg-paper-2 transition-colors"
        >
          <div className="relative">
            <Avatar size="md" name={r.name} id={r.id} />
            <div
              className="absolute -bottom-1 -left-1 bg-orange text-white rounded-full w-[20px] h-[20px] grid place-items-center text-[10px] font-bold border-2 border-white"
            >
              {i + 1}
            </div>
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-bold truncate text-[13px]">{r.name}</div>
            {r.cardNo ? (
              <div className="text-ink-3 text-[11px]">الكارت {r.cardNo}</div>
            ) : null}
          </div>
          <div className="font-bold text-orange-deep text-[13px]">{formatIQD(r.total)}</div>
        </div>
      ))}
    </div>
  );
}
